<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      class="term"
      :value="this.$store.state.commonForms[`${model}Text`]"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker[model] = true"
    />
    <van-popup v-model="showTermPicker[model]" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsTerm"
        @cancel="showTermPicker[model] = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div class="term">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BWSelect',
  props: ['label', 'model', 'placeholder', 'columnsTerm'],
  data() {
    return {
      showTermPicker: {
        [this.model]: false,
      },
    };
  },

  methods: {
    onConfirm(value) {
      const textKey = `${this.model}Text`;
      this.$store.dispatch('commonForms/updateCommon', {
        [textKey]: value.text,
        [this.model]: value.value,
      });
      this.showTermPicker[this.model] = false;
      console.log('text', this.model, this.text, this.$store.state.perfect);
    },
  },
};
</script>
<style>
.van-field__label {
  text-align: left;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #DDDEE1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.van-picker__cancel, .van-picker__confirm{
  color: #FF6538;
}
</style>
